<template>
  <div>      
    <div style="text-align:center;padding-bottom:15px;"><img src="../../assets/nexa/logo.png" width="100"></div>
      
    <div :style="styleObject">
      <div v-if="!working">
        <div v-if="!loggedIn && !errorMessage.length">
          <div class="item">
            <input type="email" v-model="email" placeholder="E-post">
          </div>
          
          <div class="item">
            <input type="password" v-model="password" placeholder="Lösenord" v-on:keyup.enter="login">
          </div>
          
          <div class="item"><button @click="login" :disabled="!ok">Logga in</button></div>
          <div class="item"><button @click="register">Registrera dig eller koppla ny Bridge</button></div>
          <div style="font-size:12px;"><router-link to="resetpass">Har du glömt ditt lösenord? Återställ det här</router-link></div>
        </div>
        <div v-else-if="bridges.length > 0">
          <h4>Anslut till...</h4>
          
          <div class="descr">Nedanför ser du dina anslutna Bridgar, tryck på en av dessa för att ansluta till den.</div>
          <table>
            <tbody>
              <tr v-for="bridge in bridges" @click="selectBridge(bridge)" :style="{ color: (bridge.connected ? '#000' : '#d2d2d2') }">
                <td>{{ bridge.info.name }}</td>
                <td align="right">
                  <span v-if="!bridge.loading">&rarr;</span>
                  <spring-spinner v-if="bridge.loading" :animation-duration="1700" :size="20" color="#033873" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="errorMessage.length">
          <span style="color:red;margin-bottom:10px;">{{ errorMessages[errorMessage] }}</span>
          <button @click="goBack">Gå tillbaka</button>
        </div>
      </div>
      <div v-else-if="working" class="center">
        <spring-spinner :animation-duration="1700" :size="50" color="#033873" />
      </div>
    </div>

    <div style="font-size:12px;margin-top:5px;"><a style="color:#707070;" href="https://nexa.se/beta" target="_blank">Hjälp oss att testa nya funktioner!</a></div>
  </div>
</template>

<script>
  import { SpringSpinner } from 'epic-spinners'
  import { cloud, cloud2 } from '../../http.js'
  import { eventbus } from '../../eventbus.js'
import axios from 'axios'

  export default {
    name: 'loggain',
    components: {
      SpringSpinner
    },
    data () {
      return {
        email: '',
        password: '',
        working: false,
        bridges: [],
        loggedIn: false,
        errorMessages: {
          nobridgeassociated: 'Du har ingen Nexa Bridge kopplad till ditt konto',
          wrongauth: 'Det verkar som om du har angivit felaktig e-post eller lösenord, försök igen',
          nobridgeconnected: 'Du har en eller flera Bridgar kopplade till ditt konto men ingen av dessa är anslutna.'
        },
        errorMessage: ''
      }
    },
    created () {},
    methods: {
      async login () {
        // Sätt e-post samt hashat lösenord i cookies
        this.working = true
        
        const cloudLogin = axios.create({
          baseURL: 'https://api.nexabridge.se'
        })
          
        const res = await cloudLogin.post('account/login', {
          email: this.email,
          password: this.password
        })
        
        const login = res.data

        if (login.success) {
          const hash = btoa('X:' + login.token)
          this.$cookie.set('password', login.token, { expires: '1D' })
          this.$cookie.set('hash', hash, { expires: '1D' })
          this.$cookie.set('email', 'X', { expires: '1D' })

          const cloud3 = axios.create({
            baseURL: 'https://api.nexabridge.se',
            headers: {
              Authorization: 'Basic ' + hash
            }
          })

          let bridges = await cloud3.get('bridges')
          bridges = bridges.data
          
          const connected = bridges.filter(bridge => bridge.connected)

          // Det finns bara en Bridge på kontot så vi väljer den för
          // användaren direkt och automatiskt. Han kommer aldrig se någon vy
          // för att välja en Bridge.
          if (connected.length === 1) {
            this.selectBridge(connected[0])
          } else if (connected.length > 1) {
            // Om användaren har fler än en Nexa Bridge kopplad till sitt konto
            // och som är anslutna så kommer vi att visa dessa för användaren.
            this.bridges = connected.map(bridge => {
              bridge.loading = false
              return bridge
            })
            
            this.working = false
          } else {
            // Användaren har ingen Bridge kopplad till sitt konto, på något sätt
            // måste vi notififera han om detta.
            this.errorMessage = (bridges.length === 0 ? 'nobridgeassociated' : 'nobridgeconnected')
            
            this.working = false
          }

          this.loggedIn = true
        }
        else {
          this.errorMessage = 'wrongauth'
          this.working = false
        }
        
        
        /*
        // Försöker hämta Bridgarna för användaren så vi kan avgöra om han lyckades
        // logga in samt hur många han har på sitt konto.
        cloud.get('bridges', {
          headers: {
            Authorization: 'Basic ' + btoa(this.email + ':' + this.password)
          }
        })
        .then(res => res.data)
        .then(json => {
          const connected = json.filter(bridge => bridge.connected)

          // Det finns bara en Bridge på kontot så vi väljer den för
          // användaren direkt och automatiskt. Han kommer aldrig se någon vy
          // för att välja en Bridge.
          if (connected.length === 1) {
            this.selectBridge(connected[0])
          } else if (connected.length > 1) {
            // Om användaren har fler än en Nexa Bridge kopplad till sitt konto
            // och som är anslutna så kommer vi att visa dessa för användaren.
            this.bridges = connected.map(bridge => {
              bridge.loading = false
              return bridge
            })
            
            this.working = false
          } else {
            // Användaren har ingen Bridge kopplad till sitt konto, på något sätt
            // måste vi notififera han om detta.
            this.errorMessage = (json.length === 0 ? 'nobridgeassociated' : 'nobridgeconnected')
            
            this.working = false
          }

          this.loggedIn = true
        }).catch(e => {
          this.errorMessage = 'wrongauth'
          this.working = false
        })*/
      },
      
      goBack () {
        this.errorMessage = ''
      },
      
      /**
        Denna funktionen körs när man väljer en Nexa Bridge att ansluta till,
        den körs även direkt om användaren bara har en Bridge kopplad till sitt konto
      */
      selectBridge (bridge) {
        // Bridgen är inte ansluten till molnet vilket betyder
        // att man heller inte kan logga in på den just nu.
        if (!bridge.connected) {
          alert('Bridgen är inte ansluten...')
        } else {
          const bridgeId = bridge.id

          this.$cookie.set('bridgeId', bridgeId, { expires: '1D' })
          //this.$cookie.set('email', this.email, { expires: '1D' })
          //this.$cookie.set('hash', btoa(this.email + ':' + this.password), { expires: '1D' })
          //this.$cookie.set('password', this.password, { expires: '1D' })

          bridge.loading = true
          
          

          // Vi måste köra window.location.reload() för att åter-initiera
          // HTTP-klienten då den redan har laddats in en gång men den gången
          // utan bridgeId.
          setTimeout(() => {
            window.location.reload()
          }, 500)
        }
      },
      
      /**
        Skickar vidare användaren till start.nexa.se där han eller hon
        får möjligheten att registrera som sig bör.
      */
      register () {
        window.location = 'https://start.nexa.se/'
      }
    },
    computed: {
      ok () {
        return this.email.length > 5 && this.password.length > 3
      },

      // Vi lägger stylingen på rutan på en separat funktion då vi
      // inte vill visa en border när vi visar laddningsindikatorn.
      styleObject () {
        return {
          border: (!this.working ? '1px solid #e7e7e7' : '0px'),
          width: '350px',
          'border-radius': '4px',
          padding: '12px'
        }
      }
    }
  }
</script>

<style scoped>
  .item {
    padding-bottom:7px;
  }
  
  .center {
    display:flex;
    justify-content:center;
    align-items:center;
  }
  
  .descr {
    font-size:12px;
    margin-bottom:10px;
  }
  
  .loginbox {
    width:350px;
    height:150px;
  }
  
  .loginbox2 {
    -webkit-box-shadow: 0px 0px 33px -10px rgba(0,0,0,0.55);
    -moz-box-shadow: 0px 0px 33px -10px rgba(0,0,0,0.55);
    box-shadow: 0px 0px 33px -10px rgba(0,0,0,0.55);
    border-radius:8px;
    border:1px solid #d2d2d2;
    width:100%;
    height:100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/loggain.vue